import { IFileReference } from "@iluvatar/global/src/typings";
import { isObject } from "@iluvatar/global/src/utilities";

import { FileSystemRef } from "../file-system";

export type LocalFileRef = {
  metadata: {
    contentType: string;
    size: number;
    name: string;
    uploadTaskId: string;
    userId?: string;
    [key: string]: unknown;
  };
  /** Destination path, available before the background transfer starts. */
  uploadRef?: string;
  fileSystemRef: FileSystemRef;
  fileUUID: string;
};

export function isRemoteFileRef(obj: unknown): obj is IFileReference {
  return isObject(obj) && Object.getOwnPropertyNames(obj).includes("ref");
}

export function isLocalFileRef(obj: unknown): obj is LocalFileRef {
  return (
    isObject(obj) && Object.getOwnPropertyNames(obj).includes("fileSystemRef")
  );
}

/**
 * On refresh of page the stored file selections are invalid (I don't know of a way to maintain the file selections) so we need to filter out the invalid ones
 */
export function isValidFileRef(
  file: Partial<LocalFileRef | IFileReference>,
): file is LocalFileRef | IFileReference {
  return isRemoteFileRef(file) || isLocalFileRef(file);
}

export type FileRecord = Record<string, LocalFileRef[] | undefined>;
